// 1. React and DOM imports

// 2. External libraries
import { useQuery } from '@tanstack/react-query';

// 3. Internal components

// 4. Type imports
import type { UseQueryResult } from '@tanstack/react-query';
import type { ConnectionResponse } from '~/generated/api/model';

// 5. Custom hooks and utilities
import { listConnectionsV1TopicsTopicIdConnectionsGet } from '~/generated/api/connections/connections';
import { queryKeys } from './queryKeys';

interface UseConnectionsQueryOptions {
  type?: 'rest' | 'mcp' | 'webhook';
  enabled?: boolean;
}

export function useConnectionsQuery(
  topicId: string | undefined,
  options?: UseConnectionsQueryOptions
): UseQueryResult<ConnectionResponse[], Error> {
  const { type, enabled = true } = options ?? {};

  return useQuery<
    ConnectionResponse[],
    Error,
    ConnectionResponse[],
    readonly ['connections', string | undefined, string | undefined]
  >({
    queryKey: queryKeys.connections.list(topicId, type),
    queryFn: async () => {
      if (!topicId) throw new Error('Topic ID is required');
      return listConnectionsV1TopicsTopicIdConnectionsGet(topicId, { type });
    },
    enabled: !!topicId && enabled,
  });
}
